// Predefined workflow templates.
// Each template contains nodes and edges that get loaded into the editor.

const uid = () => crypto.randomUUID();

export const WORKFLOW_TEMPLATES = [
  {
    key: 'event_email',
    label: 'Event Notification',
    description: 'Send an email via SendGrid when a WalletTwo event fires',
    icon: 'Mail',
    build: () => {
      const triggerId = uid();
      const emailId = uid();
      return {
        nodes: [
          { id: triggerId, type: 'triggerNode', position: { x: 250, y: 80 }, data: { label: 'WalletTwo Event', nodeType: 'trigger_wallettwo', description: 'Triggered by a WalletTwo system event' } },
          { id: emailId, type: 'actionNode', position: { x: 250, y: 280 }, data: { label: 'SendGrid', nodeType: 'action_sendgrid', description: 'Send an email via SendGrid' } },
        ],
        edges: [
          { id: uid(), source: triggerId, target: emailId, animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
        ],
      };
    },
  },
  {
    key: 'event_slack',
    label: 'Slack Alert',
    description: 'Post to Slack when a WalletTwo event occurs',
    icon: 'MessageSquare',
    build: () => {
      const triggerId = uid();
      const slackId = uid();
      return {
        nodes: [
          { id: triggerId, type: 'triggerNode', position: { x: 250, y: 80 }, data: { label: 'WalletTwo Event', nodeType: 'trigger_wallettwo', description: 'Triggered by a WalletTwo system event' } },
          { id: slackId, type: 'actionNode', position: { x: 250, y: 280 }, data: { label: 'Slack', nodeType: 'action_slack', description: 'Send a Slack message' } },
        ],
        edges: [
          { id: uid(), source: triggerId, target: slackId, animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
        ],
      };
    },
  },
  {
    key: 'webhook_api',
    label: 'Webhook to API',
    description: 'Receive a webhook and forward to an external API',
    icon: 'Webhook',
    build: () => {
      const triggerId = uid();
      const apiId = uid();
      return {
        nodes: [
          { id: triggerId, type: 'triggerNode', position: { x: 250, y: 80 }, data: { label: 'Webhook', nodeType: 'trigger_webhook', description: 'Triggered by an HTTP request', secretKey: (() => { const c='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; let r='whk_'; for(let i=0;i<32;i++) r+=c[Math.floor(Math.random()*c.length)]; return r; })() } },
          { id: apiId, type: 'actionNode', position: { x: 250, y: 280 }, data: { label: 'API Request', nodeType: 'action_api_request', description: 'Make an HTTP request to any API' } },
        ],
        edges: [
          { id: uid(), source: triggerId, target: apiId, animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
        ],
      };
    },
  },
  {
    key: 'schedule_members',
    label: 'Scheduled Member Check',
    description: 'Periodically fetch members and notify via SendGrid',
    icon: 'Clock',
    build: () => {
      const triggerId = uid();
      const membersId = uid();
      const forEachId = uid();
      const emailId = uid();
      return {
        nodes: [
          { id: triggerId, type: 'triggerNode', position: { x: 250, y: 60 }, data: { label: 'Schedule', nodeType: 'trigger_schedule', description: 'Run on a time schedule' } },
          { id: membersId, type: 'wallettwoNode', position: { x: 250, y: 240 }, data: { label: 'Get Members', nodeType: 'wallettwo_get_members', description: 'Retrieve multiple members with filters' } },
          { id: forEachId, type: 'conditionNode', position: { x: 250, y: 420 }, data: { label: 'For Each', nodeType: 'logic_foreach', description: 'Loop through a list of items' } },
          { id: emailId, type: 'actionNode', position: { x: 250, y: 600 }, data: { label: 'SendGrid', nodeType: 'action_sendgrid', description: 'Send an email via SendGrid' } },
        ],
        edges: [
          { id: uid(), source: triggerId, target: membersId, animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
          { id: uid(), source: membersId, target: forEachId, animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
          { id: uid(), source: forEachId, target: emailId, animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
        ],
      };
    },
  },
  {
    key: 'event_condition',
    label: 'Conditional Notification',
    description: 'Check a condition on an event and send different notifications',
    icon: 'GitBranch',
    build: () => {
      const triggerId = uid();
      const conditionId = uid();
      const emailId = uid();
      const slackId = uid();
      return {
        nodes: [
          { id: triggerId, type: 'triggerNode', position: { x: 300, y: 60 }, data: { label: 'WalletTwo Event', nodeType: 'trigger_wallettwo', description: 'Triggered by a WalletTwo system event' } },
          { id: conditionId, type: 'conditionNode', position: { x: 300, y: 240 }, data: { label: 'Condition', nodeType: 'logic_condition', description: 'Branch based on a condition' } },
          { id: emailId, type: 'actionNode', position: { x: 120, y: 440 }, data: { label: 'SendGrid', nodeType: 'action_sendgrid', description: 'Send an email via SendGrid' } },
          { id: slackId, type: 'actionNode', position: { x: 480, y: 440 }, data: { label: 'Slack', nodeType: 'action_slack', description: 'Send a Slack message' } },
        ],
        edges: [
          { id: uid(), source: triggerId, target: conditionId, animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
          { id: uid(), source: conditionId, target: emailId, sourceHandle: 'true', animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
          { id: uid(), source: conditionId, target: slackId, sourceHandle: 'false', animated: true, style: { stroke: '#94a3b8', strokeWidth: 2 } },
        ],
      };
    },
  },
];
